import "temporal-polyfill/global";

export default defineNuxtPlugin(() => {
  // temporal polyfill global import - no runtime plugin logic required
});
